import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'src/app/hooks';
import { addModal, removeModal } from 'src/features/globalSlice';
import { ModalType } from 'src/store/models/Modal';

import { useBlocker } from './useBlocker';

const useCustomPrompt = (message: string, shouldPrompt: boolean): void => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const shouldShowPrompt = useMemo(() => shouldPrompt, [shouldPrompt]);

  const handleBlockNavigation = ({ retry }: { retry: () => void }) => {
    if (shouldShowPrompt) {
      dispatch(
        addModal({
          title: t('common:are_you_sure'),
          body: message,
          modalType: ModalType.WARNING,
          primaryButtonText: t('common:yes'),
          secondaryButtonText: t('common:no'),
          primaryAction: () => {
            dispatch(removeModal());
            retry?.();
          },
          secondaryAction: () => {
            dispatch(removeModal());
          },
        })
      );
    } else {
      retry();
    }
  };

  useBlocker(handleBlockNavigation, shouldShowPrompt);
};

export default useCustomPrompt;
